export enum CustodianCode {
  FIDELITY = 'FIDELITY',
  USBANK = 'USBANK',
  BNYMELLON = 'BNYMELLON',
  STATESTREET = 'STATESTREET',
  ROBUSTWEALTH = 'ROBUSTWEALTH',
  APEX = 'APEX',
}

export enum CustodianId {
  FIDELITY = 2,
  USBANK = 3,
  BNYMELLON = 4,
  STATESTREET = 5,
  ROBUSTWEALTH = 6,
  APEX = 7,
}

export interface Custodian {
  name: string;
  code: CustodianCode;
  id: CustodianId;
}

export const CUSTODIANS: Record<CustodianCode, Custodian> = Object.freeze({
  [CustodianCode.FIDELITY]: {name: 'Fidelity', code: CustodianCode.FIDELITY, id: CustodianId.FIDELITY},
  [CustodianCode.USBANK]: {name: 'US Bank', code: CustodianCode.USBANK, id: CustodianId.USBANK},
  [CustodianCode.BNYMELLON]: {name: 'BNY Mellon', code: CustodianCode.BNYMELLON, id: CustodianId.BNYMELLON},
  [CustodianCode.STATESTREET]: {name: 'State Street', code: CustodianCode.STATESTREET, id: CustodianId.STATESTREET},
  [CustodianCode.ROBUSTWEALTH]: {
    name: 'RobustWealth Custodian Test',
    code: CustodianCode.ROBUSTWEALTH,
    id: CustodianId.ROBUSTWEALTH,
  },
  [CustodianCode.APEX]: {name: 'Apex Clearing', code: CustodianCode.APEX, id: CustodianId.APEX},
});
